import * as CircularJSON from 'circular-json';
import {reportBiError} from '../statistics/bi';
import {getWixParams} from '../statistics/send-event';
import {safe} from '../utils/functions';

export function addNewRelicAttributes() {
  if (typeof newrelic === 'undefined') {
    return;
  }
  const wixParams = getWixParams();
  newrelic.setCustomAttribute('uid', wixParams.userId);
  newrelic.setCustomAttribute('componentId', wixParams.compId);
  newrelic.setCustomAttribute('instanceId', wixParams.instanceId);
  newrelic.setCustomAttribute('isOwner', wixParams.isOwner);
  newrelic.setCustomAttribute('biToken', wixParams.biToken);
}
function getNewRelicAttrs() {
  const wixParams = getWixParams();
  return {
    uid: wixParams.userId,
    componentId: wixParams.compId,
    instanceId: wixParams.instanceId,
    isOwner: wixParams.isOwner,
    biToken: wixParams.biToken,
  }
}

export function logError(errorDescription, arg0?, ...args) {
  if (!errorDescription) {
    console.error('Invalid argument to log error');
    logErrorToNewRelic('Invalid argument to log error');
    return;
  }
  console.error('Wix Music Error: ', errorDescription.name || errorDescription, arg0 && arg0.reason || arg0, ...args); //eslint-disable-line no-console
  if (errorDescription.name && errorDescription.id) {
    reportBiError(errorDescription, arg0);
  } else {
    reportBiError({id: 1999, name: 'unhandled-error'});
  }

  logErrorToNewRelic(errorDescription, arg0);
}
let playerStartedFired = false;

export function logPlayerStarted() {
  if (typeof newrelic === 'undefined' || playerStartedFired) {
    return;
  }
  newrelic.addPageAction('player-started');
  newrelic.finished();
  playerStartedFired = true;
}

export function logMetricToNewRelic(eventName, args?) {
  if (typeof newrelic === 'undefined') {
    return;
  }
  newrelic.addPageAction(eventName, args);
  newrelic.addToTrace({eventName, ...args});
}

function serialiseReason(reason: any) {
  if (!reason) {
    return reason;
  }

  if (reason instanceof Error) {
    return {
      name: reason.name,
      message: reason.message,
      stack: reason.stack
    };
  }

  if (reason instanceof Event) {
    return {
      type: reason.type,
      className: reason.constructor && reason.constructor.name
    }
  }
  return {
    'typeof': typeof reason,
    className: reason.constructor && reason.constructor.name
  }
}

function logErrorToNewRelic(description, opts: any = {}) {
  if (typeof newrelic === 'undefined') {
    return;
  }
  let options = {
    type: 'custom',
    message: description,
    ...getNewRelicAttrs(),
    ...opts,
    reason: serialiseReason(opts.reason),
    reasonText: safe(CircularJSON.stringify)(opts.reason)
  };

  if (description.name && description.id) {
    options = {
      ...options,
      type: 'bi',
      message: description.name,
      biId: description.id,
      biName: description.name
    };
    if (description.severity) {
      options.biSeverity = description.severity;
    }
  }

  if (opts.reason instanceof Error) {
    options = {
      ...options,
      errorName: opts.reason.name,
      errorMessage: opts.reason.message
    };
  }

  newrelic.addPageAction('error', options);
  newrelic.noticeError(getError(description, options));
}

function getError(description, options) {
  try {
    if (description.error) {
      description.error();
    }
    else {
      throw new Error(options.message);
    }
  } catch (ex) {
    return ex;
  }
}



// WEBPACK FOOTER //
// ./logging/logging.ts